export const icecatLiveStyles = () => {

	return `body { 
				--pet-font-family: mikado-regular;
				--pet-font-size: 14px;
				--pet-font-weight: 500;
				--pet-color: #000000;
				--pet-theme-color: #475be9;
				--pet-headding-font-family: mikado-bold;
				--pet-h1-font-family: mikado-regular;
				--pet-h2-font-family: mikado-regular;
				--pet-h3-font-family: mikado-regular;
				--pet-h4-font-family: mikado-regular;
				--pet-h5-font-family: mikado-bold;
				--pet-h6-font-family: mikado-regular;
			}`
};